"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: e, size: o = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = n(), a = e !== null && e !== void 0 ? e : s ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ r("path", {
            fill: a,
            d: "M16.241 7.757h4.146c.804 0 1.46.656 1.456 1.46v11.165a1.46 1.46 0 0 1-1.459 1.46H9.222c-.804 0-1.46-.656-1.46-1.46v-4.143H3.67c-.832 0-1.51-.678-1.51-1.51V3.665c0-.835.675-1.51 1.507-1.51H14.73c.832 0 1.51.675 1.51 1.51zM3.434 14.73c0 .13.104.233.233.236H14.73a.237.237 0 0 0 .236-.236V3.665a.237.237 0 0 0-.236-.235H3.67a.237.237 0 0 0-.236.235zm17.138 5.653V9.217a.183.183 0 0 0-.185-.185h-4.143v5.694c0 .832-.678 1.51-1.51 1.51H9.04v4.146c0 .1.082.185.185.185h11.163c.1 0 .185-.082.185-.185"
        })
    }));
}, p = i;
export { p as default };
